import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import GoogleMapRadius from "../../../components/GoogleMapRadius/GoogleMapRadius";
import {useSelector} from "react-redux";

const Heading = styled.h3`
  font-size: 23px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
  text-align: center;
`;

const SubHeader = styled.h5`
  font-size: 17px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  margin-bottom: 25px;
  width: 100%;
`;

const MiniHeader = styled.h5`
  font-size: 14px;
  font-weight: 700;
  color: #0d1136;
  line-height: 1.2;
  width: 100%;
`;

const Li = styled.li`
  margin: 0px !important;
  padding: 5px !important;
`

const DeliveryInfoKhmer = () => {
  const [latitude] = useState(11.558661);
  const [longitude] = useState(104.912052);

  const DelishopSection = () => (
      <>
        <div className="mb-4">
          <SubHeader className="mb-2"><u>ម៉ោងដឹកជញ្ជូន:</u></SubHeader>
          <div>
            រាល់ការកម្មង់នៅលើវេបសាយរបស់យើងខ្ញុំនិងត្រូវដឹកជញ្ជូនក្នុងថ្ងៃតែមួយឬក៏ថ្ងៃបន្ទាប។
          </div>
          <div>
	          យើងខ្ញុំដំណើរការពីម៉ោង ១០ព្រឹក ដល់ ម៉ោង ៨យប់ ថ្ងៃចន្ទ័ ដល់ អាទិត្យ។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ការដឹកក្នុងថ្ងៃតែមួយ:</u></SubHeader>
          <div className="mb-2">
            លោកអ្នកនឹងទទួលបានការដឹកជញ្ជូនក្នុងថ្ងៃតែមួយ ប្រសិនបើធ្វើការកម្មង់មុនម៉ោង២រសៀល។ លោកអ្នកអាចសម្គាល់ពីផលិតផលដែលអាចដឹកក្នុងថ្ងៃតែមួយបានដោយ មានឃ្លារបញ្ចាក់ថា(ទទួលបានឥវ៉ាន់ថ្ងៃនេះ)។
          </div>

          <div>
            ប្រសិនបើមានផលិតផលណានៃកន្ទ្រក់របស់អ្នកដែរមិនអាចដឹកជូនក្នុងថ្ងៃតែមួយ។ លោកអ្នកគ្រាន់តែលុបផលិតផលនោះចេញពីកន្ទ្រក់របស់អ្នកនោះ លោកអ្នកនិងអាចទទួលបានការដឹកជញ្ជូនក្នុងថ្ងៃតែមួយភ្លាមៗ។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ព័ត៌មានទូរទាត់ប្រាក់:</u></SubHeader>
          <div>
            -ការកម្មង់តិចបំផុត ១០ដុល្លារ
          </div>
          <div className="mb-2">
            -អត្រាប្តូរ១ដុល្លារ ៤១០០រៀល
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ជម្រើសនៃការទូរទាត់ប្រាក់:</u></SubHeader>
          {/* <div>
            -តាមរយៈសាច់ប្រាក់៖ ជាលុយខ្មែរ ឬដុល្លារ
          </div>
          <div>
            -តាមរយៈអេប៊ីអេ ឬស្កេនឃូអរ័កូដនៅលើវិកយ័បត្រ័ នៅពេលអ្នកបានឥវ៉ាន់
          </div>
          <div>
            -លោកអ្នកធ្វើការទូទាត់ភ្លាមៗ តាមអេប៊ីអេ វីសាកាត ម៉ាស័រកាត
          </div> */}
          <ul style={{listStyleType: "disc"}}>
            <Li>កំឡុងពេល ទូទាត់ : ទូទាត់តាមរយះ ធនាគារ​ ក្នុងស្រុក, KHQR, Visa/Master, WeChat Pay, AliPay</Li>
            <Li>តាមអ្នកដឹកជញ្ជូន : ទូទាត់ជា (ប្រាក់ដុល្លា ឬ ប្រាក់រៀល), ABAPay, KHQR</Li>
          </ul>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ព័ត៌មានដឹកជញ្ជូន:</u></SubHeader>
          <div className="mb-2">
            លោកអ្នកអាចជ្រើសរើសការដឹកជញ្ជូនក្នុងកំឡុងពេល១ម៉ោងបានក្នុងការកម្មង់របស់លោកអ្នក អ្នកដឹកជញ្ជូនរបស់យើងនិងធ្វើការដឹកឥវ៉ាន់ទៅដល់ទ្វារផ្ទះរបស់លោកអ្នក (ប្រសិនបើលោកអ្នករស់នៅក្នុងអាផាតមិន ត្រូវប្រាកដថាអាចអោយអ្នកដឹកជញ្ជូនយើងខ្ញុំចូលក្នុងអាផាតមិនបាន)។
            ប្រសិនបើមានករណីចាំបាច់ណាមួយតម្រូវអោយមានការពន្យាពេលដឹកជញ្ជូន អ្នកតំណាងសេវាកម្មយើងខ្ញុំនិងធ្វើការទំនាក់ទំនងទៅដើម្បីធ្វើការជ្រើសរើសពេលម៉ោងនិងពេលវេលាម្ដងទៀត។
          </div>

          <div>
            ម្យ៉ាងវិញទៀតលោកអ្នកក៏អាចពឹងអ្នកដទៃអោយទទួលឥវ៉ាន់ជំនួសអស់លោកអ្នកផងដែរ(អ្នកគ្រប់គ្រងអាផាតមិន អ្នកជិតខាង សន្តិសុខជាដើម)។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>តម្លៃដឹកជញ្ជូន:</u></SubHeader>
          <div className="mb-3">
            ថ្លៃដឹកជញ្ជូនត្រូវបានកំណត់សម្រាប់ទីក្រុងភ្នំពេញ ត្រូវបានបែងចែកខាងក្រោម៖
          </div>

          <div className="mb-3">
            <MiniHeader className="mb-1">
              គោលដៅទី១៖ ៥គីឡូមែត្រពីកណ្ដាលទីក្រុង
            </MiniHeader>
	          <div>ថ្លៃដឹក១គីឡូមែត្រ ០.២៦ ដុល្លារ</div>
            <div>កម្មង់ចាប់ពី ៥០ដុល្លារឡើងទៅនឹងទទួលបានការដឹកដោយឥគិតថ្លៃ</div>
          </div>

          <div className="mb-2">
            <MiniHeader className="mb-1">គោលដៅទី២៖ ១៧គីឡូម៉ែត្រពីកណ្ដាលទីក្រុង </MiniHeader>
	          <div>ថ្លៃដឹក១គីឡូមែត្រ ០.២៦ ដុល្លារ</div>
            <div>កម្មង់ចាប់ពី ១០០ដុល្លារឡើងទៅនឹងទទួលបានការដឹកដោយឥគិតថ្លៃ</div>
          </div>

          <div>ប្រសិនបើទីតាំងរបស់លោកអ្នកមិនស្តិតក្នុងគោលដៅទាំងពីរនេះទេ យើងខ្ញុំនឹងផ្ងើឥវ៉ាន់លោកអ្នកតាមរយះឡានក្រុង។</div>
        </div>

        <div>
          <GoogleMapRadius
              isMarkerShown={true}
              latitude={latitude}
              longitude={longitude}
              cartType='normal'
              zoom={11.3}
          />
        </div>
      </>
  )

  const DeliExpressSection = () => (
      <>
        <div className="mb-4 mt-5 pt-5">
          <SubHeader className="mb-2" style={{fontSize: "21px", fontWeight: "bold", color: "#f01266"}}>ដេលីស៊ប អ៊េចស្ព្រេស</SubHeader>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ពេលវេលាដឹកជញ្ជូន:</u></SubHeader>
          <div>
            រាល់ការកម្មង់តាមដេលីស៊ប អ៊េចស្រ្ពេសទាំងអស់យើងខ្ញុំនឹងធ្វើការដឹកយ៉ាងឆាប់រហស័បំផុតអាស្រ័យលើទីតាំងហាងដែរលោកអ្នកបានកម្មង់ យ៉ាងយូរបំផុត៤៥-៦០នាទី។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ព័ត៌មានទូរទាត់ប្រាក់:</u></SubHeader>
          <div>
            -ការកម្មង់តិចបំផុត៖ ១០ដុល្លារ
          </div>
          <div>
            -អត្រាប្ដូរប្រាក់៖ ១ដុល្លារ =៤១០០ រៀល
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ជម្រើសនៃការទូរទាត់ប្រាក់:</u></SubHeader>
          {/* <div>
            -តាមរយៈសាច់ប្រាក់៖ ជាលុយខ្មែរ ឬដុល្លារ
          </div>
          <div>
            -តាមរយៈអេប៊ីអេ ឬស្កេនឃ្យូអរ័កូត នៅលើវិកយ័បត្រ័ នៅពេលអ្នកបានឥវ៉ាន់
          </div>
          <div>
            -លោកអ្នកធ្វើការទូទាត់ភ្លាមៗ តាមអេប៊ីអេ វីសាកាត ម៉ាស័រកាត
          </div> */}
          <ul style={{listStyleType: "disc"}}>
            <Li>កំឡុងពេល ទូទាត់ : ទូទាត់តាមរយះ ធនាគារ​ ក្នុងស្រុក, KHQR, Visa/Master, WeChat Pay, AliPay</Li>
            <Li>តាមអ្នកដឹកជញ្ជូន : ទូទាត់ជា (ប្រាក់ដុល្លា ឬ ប្រាក់រៀល), ABAPay, KHQR</Li>
          </ul>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ទីតាំងដឹកជញ្ជូន:</u></SubHeader>
          <div>
            សម្រាប់អតិថិជនដែលមានទីតាំងដូចក្នុងផែនទីខាងក្រោម អាចធ្វើការកម្មង់តាម ដេលីស៊ប អ៊េចស្រ្ពេសបាន។
          </div>
        </div>

        <div>
          <GoogleMapRadius
              isMarkerShown={true}
              latitude={latitude}
              longitude={longitude}
              cartType='express'
              zoom={13.4}
          />
        </div>
      </>
  )

  const ProvinceSection = () => (
      <>
        <div className="mb-4 mt-5 pt-5">
          <SubHeader className="mb-2" style={{fontSize: "21px", fontWeight: "bold", color: "orange"}}>សម្រាប់អ្នកតាមបណ្ដាខេត្ត:</SubHeader>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>លក្ខខណ្ឌដឹកជញ្ជូន:</u></SubHeader>
          <div className="mb-2">
            យើងខ្ញុំក៏មានសេវាកម្មដឹកជញ្ជូនតាមបណ្ដាខេត្តនានាផងដែរ ដោយលោកអ្នកគ្រាន់តែបំពេញនូវអាស្រ័យដ្ឋាន និងធ្វើការជ្រើសយក(បណ្ដាខេត្ត)
            នោះអស់លោកអ្នកនិងអាចធ្វើការកម្មង់គ្រប់ប្រភេទផលិតផលទាំងអស់ដែរយើងខ្ញុំមាន ហើយនឹងធ្វើការផ្ញើឥវ៉ាន់លោកអ្នកតាមឡានក្រុង។
            នៅពេលដែលឥវ៉ាន់ទៅដល់ លោកអ្នកនឹងទទួលតាមរយៈស្ថាននីយ៍ឡានក្រុងដែរជិតលោកអ្នកបំផុត។ ក្រុមហ៊ុនដែលយើងខ្ញុំសហការជាមួយមាន វីរះប៊ុន ថាំ និង ជេ&ធី អេចស្រ្ពេស។
          </div>

          <div className="mb-2">
            ប្រសិនបើលោកអ្នកកម្មង់ឥវ៉ាន់ស្រស់ ឬ កក ពួកយើងនឹងខ្ចាប់វាក្នុងធុងស្នោរជាមួយនិងដុំទឹកកករក្សាភាពត្រជាក់។ ទោះបីជាយ៉ាងណាក័ដោយ យើងខ្ញុំមិនណែនាំនូវជម្រើសមួយនេះនោះទេប្រសិនបើធ្វើការផ្ញើតាមឡានក្រុង។ព្រោះការខ្ចាប់បែបនេះមិនធានារអោយបាននូវគុណភាពឥវ៉ាន់នោះទេ ខាងយើងខ្ញុំក៏មិនធានាទៅលើគុណភាពផងដែរ។
          </div>

          <div>
            លើសពីនេះទៀត ការចំណាយលើការខ្ចាប់អាស្រ័យលើការប្រើ ធុងស្នោជាក់ស្ដែងទៅតាមឥវ៉ាន់ច្រើនឬក៏តិច។ ជាទូទៅធុងស្នោមួយតម្លៃ ២.៥ដុល្លារ។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ពេលវេលាដឹកជញ្ជូន:</u></SubHeader>
          <div>
            រាល់ការកម្មង់ទាំងអស់នឹងត្រូវផ្ញើរទៅតាមបណ្ដាខេត្តទាំងអស់ពេលរសៀល។
          </div>
          <div className="mb-2">
             ហើយជាទូទៅរាល់ការផ្ញើរទាំងអស់នឹងទៅដល់ទីតាំងស្ថាននីយ៍អស់លោកអ្នកក្នុងកំឡុងពេលព្រឹកថ្ងៃបន្ទាប់(ទៅតាមទីតាំងជិតឬក៏ឆ្ងាយ)។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ព័ត៌មាននៃការទូរទាត់ប្រាក់:</u></SubHeader>
          <div>
            -ការកម្មង់តិចបំផុត៖ ១០ដុល្លារ
          </div>
          <div className="mb-2">
            -អត្រាប្ដូរប្រាក់៖ ១ដុល្លារ =៤១០០ រៀល
          </div>
          <div>
            យើងខ្ញុំទទួលការបង់ប្រាក់តាមរយៈ ការផ្ទេរប្រាក់តាមធនាគារក្នុងស្រុក KHQR វីសាកាត ម៉ាស័រកាត WeChat Pay  AliPay ក្នុងកំឡុងលោកអ្នកកម្មង់ក្នុងកម្មវិធីឬគេហទំព័រតែប៉ុណ្ណោះ។
          </div>
        </div>

        <div className="mb-4">
          <SubHeader className="mb-2"><u>ព័ត៌មានដឹកជញ្ជូន:</u></SubHeader>
          <div>
            ការផ្ញើឥវ៉ាន់តាមរយៈឡានក្រុងតម្លៃថេរ ៤.៥ដុល្លារ
          </div>
          <div>
            ប្រសិនបើទំហំនៃការកម្មង់ច្រើនឬក៏មានការបង់បន្ថែមពីលើតម្លៃផ្ញើរផ្សេងៗ ក្រុមការងារយើងខ្ញុំនឹងធ្វើការទំនាក់ទំនងជាមុន។
          </div>
        </div>
      </>
  )

  return (
      <React.Fragment>
        <Heading>ព័ត៌មានដឹកជញ្ចូន</Heading>
        <DelishopSection/>
        <DeliExpressSection />
        <ProvinceSection/>
      </React.Fragment>
  )
}

export default DeliveryInfoKhmer;